import { InputNumberProps } from 'antd/lib/input-number'
import { currency } from '@/utils/form'
import InputNumber from './InputNumber'

const CurrencyInput = ({ ...props }: InputNumberProps) => (
  <InputNumber {...props} {...currency} />
)

export default CurrencyInput
